import { IsBoolean, IsNotEmpty } from 'class-validator';

export class ProjetoHabilitarDesabilitarVendasDto {
  @IsBoolean()
  @IsNotEmpty()
  habilitar: boolean;
}
